import { useState } from 'react';
import { Hero } from './components/Hero';
import { Introduction } from './components/Introduction';
import { Services } from './components/Services';
import { Pricing } from './components/Pricing';
import { ValueProposition } from './components/ValueProposition';
import { HowItWorksSection } from './components/HowItWorksSection';
import { CallToAction } from './components/CallToAction';
import { HomepageContactForm } from './components/HomepageContactForm';
import { ContactDetails } from './components/ContactDetails';
import { Navigation } from './components/Navigation';
import { Footer } from './components/Footer';
import { IndustriesModal } from './components/IndustriesModal';
import { HowItWorksModal } from './components/HowItWorksModal';
import { CalendarModal } from './components/CalendarModal';
import { SEO } from '../../components/SEO';

export default function HomePage() {
  const [pendingServiceTitle, setPendingServiceTitle] = useState<string | null>(null);
  const [isIndustriesOpen, setIsIndustriesOpen] = useState(false);
  const [isHowItWorksOpen, setIsHowItWorksOpen] = useState(false);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  const handleOpenService = (title: string) => {
    const el = document.getElementById('services');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    setTimeout(() => setPendingServiceTitle(title), 400);
  };

  const handleServiceModalClosed = () => {
    setPendingServiceTitle(null);
  };

  const handleBookDemo = () => {
    const el = document.getElementById('cta');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <SEO
        title="AI Phone Answering Service | Never Miss Another Customer Call"
        description="Never miss another customer call again. Our AI-powered phone answering service answers calls 24/7, follows up with leads, and books appointments automatically."
        canonical="/"
        schemas={[
          {
            type: 'Organization',
            data: {
              '@type': 'Organization',
              name: 'AI Receptionist Service',
              url: siteUrl,
              logo: `${siteUrl}/bimi/logo.svg`,
              description: 'AI-powered receptionist and phone answering service providing 24/7 automated customer support',
              contactPoint: {
                '@type': 'ContactPoint',
                contactType: 'Customer Service',
                availableLanguage: ['English']
              }
            }
          },
          {
            type: 'WebSite',
            data: {
              '@type': 'WebSite',
              name: 'AI Receptionist Service',
              url: siteUrl,
              description: 'AI-powered receptionist and phone answering service providing 24/7 automated customer support'
            }
          }
        ]}
      />
      <div className="min-h-screen bg-white">
        <Navigation />
        <Hero
          onBookDemo={() => setIsCalendarOpen(true)}
          onSeeHowItWorks={() => setIsHowItWorksOpen(true)}
        />
        <Introduction />
        <Services
          openServiceTitle={pendingServiceTitle}
          onModalClosed={handleServiceModalClosed}
        />
        <Pricing />
        <HowItWorksSection />
        <ValueProposition />
        <CallToAction />
        <HomepageContactForm />
        <ContactDetails />
        <Footer
          onOpenService={handleOpenService}
          onOpenIndustries={() => setIsIndustriesOpen(true)}
          onOpenHowItWorks={() => setIsHowItWorksOpen(true)}
        />
        <IndustriesModal
          isOpen={isIndustriesOpen}
          onClose={() => setIsIndustriesOpen(false)}
          onBookDemo={handleBookDemo}
        />
        <HowItWorksModal
          isOpen={isHowItWorksOpen}
          onClose={() => setIsHowItWorksOpen(false)}
          onBookDemo={() => {
            setIsHowItWorksOpen(false);
            setIsCalendarOpen(true);
          }}
        />
        <CalendarModal
          isOpen={isCalendarOpen}
          onClose={() => setIsCalendarOpen(false)}
        />
      </div>
    </>
  );
}
